exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TaskList-form{margin:15px;padding:15px}.TaskList-tasks{margin:15px 0;padding:15px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/containers/TaskList/TaskList.scss
// module id = 331
// module chunks = 0